import { resolveCurrency } from '@/utils/geo';
import { defaultCurrencyCode } from '@/utils/intl';

/**
 * The currency every price in the app is shown and charged in. Resolved once when the app starts,
 * in parallel with Firebase auth, so pricing screens never wait for a round trip of their own.
 */
export default {
  namespaced: true,
  state: {
    code: defaultCurrencyCode,
    country: null,
    source: 'default',
    isResolved: false,
    isResolving: false,
  },
  mutations: {
    SET_CURRENCY(state, { currency, country, source }) {
      state.code = currency;
      state.country = country;
      state.source = source;
      state.isResolved = true;
      state.isResolving = false;
    },
    SET_IS_RESOLVING(state, payload) {
      state.isResolving = payload;
    },
  },
  actions: {
    async resolve({ commit, state }, profileCurrency) {
      // A currency stored on the profile arrives later than the first call and must win
      if (state.isResolving) return state.code;
      if (state.isResolved && !profileCurrency) return state.code;

      commit('SET_IS_RESOLVING', true);

      const geo = await resolveCurrency(profileCurrency);
      commit('SET_CURRENCY', geo);

      return geo.currency;
    },
  },
};
